import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type { Group } from '../../../group'
import type { Api } from '../../api'
import type { TypeParams } from '../../types'

import { Plugin } from './plugin'

/**
 * Factory for creating sender plugin instances
 */
export class Factory
  implements ec.plugins.Plugin.Factory<TypeParams, typeof Plugin.id, Plugin>
{
  /** @see {@link Plugin.id} */
  public readonly id = Plugin.id
  /** @see {@link Api} */
  private readonly _api: Api
  /** @see {@link Group} */
  private readonly _assistantGroup: Group

  constructor({ api, assistantGroup }: Factory.constructor.Params) {
    this._api = api
    this._assistantGroup = assistantGroup
  }

  /**
   * Creates a {@link Plugin} for the given {@link ec.Collection}
   */
  public produceFor(collection: ec.Collection<TypeParams>): Plugin {
    return new Plugin({
      api: this._api,
      assistantGroup: this._assistantGroup,
      collection,
    })
  }
}

export namespace Factory {
  export namespace constructor {
    export type Params = Omit<Plugin.constructor.Params, 'collection'>
  }
}
